import React from "react";
import classNames from "classnames";
import { Paragraph, Label } from "@campgladiator/cgui-core.atoms.typography";
import { Avatar } from "@campgladiator/cgui-core.atoms.avatar";
import { centsToUSD } from "@campgladiator/cg-common.utility.numbers";
import styles from "./CreateMembershipConfirm.module.scss";

export type CreateMembershipConfirmProps = {
  couponAmountOff?: string;
  couponName?: string;
  couponPercentageDiscount?: string;
  paymentStartDate: string;
  productName: string;
  productPrice: string;
  scheduleDescription: string;
  totalDueToday: string;
  trainerName: string;
  trainerPhotoUrl: string;
  trialDays: number;
};

const CreateMembershipConfirm = ({
  couponAmountOff,
  productName,
  productPrice,
  trialDays,
  couponName,
  couponPercentageDiscount,
  paymentStartDate,
  totalDueToday,
  trainerName,
  trainerPhotoUrl,
  scheduleDescription,
}: CreateMembershipConfirmProps) => {
  const renderSection = (title: string, value: string) => (
    <section className={styles.section}>
      <Paragraph weight="book" size="default">
        {title}
      </Paragraph>
      <Paragraph weight="book" size="default">
        {value}
      </Paragraph>
    </section>
  );

  const couponLabelValue = couponAmountOff
    ? `${couponName} / ${centsToUSD(Number(couponAmountOff))} off`
    : couponName
    ? `${couponName} / ${couponPercentageDiscount}% off`
    : "-";

  return (
    <div className={styles.innerContent}>
      <article className={styles.summary}>
        {renderSection(productName, productPrice)}
        {renderSection("Payment Start Date", paymentStartDate)}
        {renderSection("Trial Days", trialDays.toString())}
        {renderSection("Coupon Name/Discount", couponLabelValue)}
        {renderSection("Total Due Today", totalDueToday)}
        <section className={styles.trainerSummary}>
          <Label className={styles.label}>
            <em>Trainer / Schedule</em>
          </Label>
          <div className={classNames(styles.details, styles.trainerDetails)}>
            <Avatar src={trainerPhotoUrl} size="60px" />
            <div className={styles.trainerSummary}>
              <Paragraph
                size="default"
                weight="bold"
                className={styles.trainerName}
              >
                {trainerName}
              </Paragraph>
              <Paragraph size="default" weight="book">
                <em>{scheduleDescription}</em>
              </Paragraph>
            </div>
          </div>
        </section>
      </article>
    </div>
  );
};
export default CreateMembershipConfirm;
